import { useReferenceOptions, type ReferenceName } from '@/stores/useReferenceOptions';

/** <option> d'une liste de référence de l'API (rôles…), triées par position (si l'API en donne une) sinon par libellé ; valeur : la référence (EMPLOYEE…) */
export function ReferenceOptions({ name }: { name: ReferenceName }) {
  const options = useReferenceOptions(name);

  return (
    <>
      {options.map((option) => (
        <option key={option.reference} value={option.reference}>
          {option.label}
        </option>
      ))}
    </>
  );
}
